export const findSegmentIndex = (targetDistance: number, distances: Float64Array): number => {
  let low = 0;
  let high = distances.length - 2;
  let idx = 0;

  while (low <= high) {
    const mid = (low + high) >>> 1;

    if (distances[mid] <= targetDistance) {
      idx = mid;
      low = mid + 1;
    } else {
      high = mid - 1;
    }
  }

  return idx;
};
